import { slugifyHeading } from '@/utils/glossary-toc';
import VisibleLoading from '@/components/utilities/VisibleLoading';

const SEGMENT_CLASSES = {
  green: 'bg-green-50 border-green-200',
  blue: 'bg-blue-50 border-blue-200',
  yellow: 'bg-yellow-50 border-yellow-200',
  red: 'bg-red-50 border-red-200',
  brand: 'bg-brand-50 border-brand-200',
  purple: 'bg-purple-50 border-purple-200',
  grey: 'bg-grey-100 border-grey-200'
};

const SegmentCard = ({ segment }) => {
  const colorClass = SEGMENT_CLASSES[segment.segmentColor] || SEGMENT_CLASSES.grey;

  return (
    <div
      className={`rounded-2xl border px-5 py-[18px] ${colorClass} ${segment.isWide ? 'sm:col-span-2' : ''}`}
    >
      <div className="mb-1 text-[15px] font-bold">{segment.name}</div>
      {segment.rfmCode && (
        <div className="mb-2 text-xs font-semibold tracking-[0.05em] opacity-70">{segment.rfmCode}</div>
      )}
      {segment.action && <div className="text-[13px] leading-[1.5]">{segment.action}</div>}
    </div>
  );
};

const GlossarySegmentsShowcase = ({ title, description, segments = [] }) => {
  if (segments.length === 0 && !title) return null;

  const headingId = title ? slugifyHeading(title) : undefined;

  return (
    <section>
      {title && (
        <VisibleLoading delay={100}>
          {({ ref, className }) => (
            <h2
              id={headingId}
              ref={ref}
              className={`text-grey-950 mt-13 mb-5 text-[32px] leading-tight font-light ${className || ''}`.trim()}
            >
              {title}
            </h2>
          )}
        </VisibleLoading>
      )}

      {description && <p className="text-grey-600 mb-5 text-base leading-[1.75]">{description}</p>}

      <div className="mt-7 grid grid-cols-1 gap-3 sm:grid-cols-2">
        {segments.map((segment) => (
          <SegmentCard key={segment.id} segment={segment} />
        ))}
      </div>
    </section>
  );
};

export default GlossarySegmentsShowcase;
